import { FavoriteButton, MainModal, PlaylistSelector } from 'components';
import React, { useEffect, useState } from 'react';

import IconPlaylist from 'assets/icons/playlist-add.svg';
import { usePlaylist } from 'modules/playlists';
import { useLocation } from 'react-router';
import { AudioPlayerCore, useAudioPlayer } from '..';

export const AudioPlayer: ReactFC = () => {
  const location = useLocation();
  const { audio, tracks, close } = useAudioPlayer();
  const { isFavorite, toggleFavorite } = usePlaylist('audio');
  const [showPlaylistModal, setShowPlaylistModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isSharedAudio] = useState(location.pathname.includes('/shared/'));

  useEffect(() => {
    return close;
  }, []);

  useEffect(() => {
    document.title = audio?.title ? `TeamMAK | ${audio.title}` : document.title;
  }, [audio]);

  const toggleExpandingPlayer = () => setExpanded(!expanded);
  const openPlaylistModal = () => setShowPlaylistModal(true);
  const closePlaylistModal = () => setShowPlaylistModal(false);

  const renderFavoriteButton = () => {
    if (!audio || isSharedAudio) return null;
    return (
      <FavoriteButton
        className="button button--ghost button--unpadded"
        isFavorite={isFavorite(audio.id)}
        toggleCallback={() => toggleFavorite(audio.id)}
      />
    );
  };

  const renderPlaylistButton = () => {
    if (isSharedAudio) return null;
    return (
      <button
        className="button button--ghost button--unpadded"
        onClick={openPlaylistModal}
      >
        <img src={IconPlaylist} alt="+=" />
      </button>
    );
  };

  const renderExpandButton = () => (
    <button
      onClick={toggleExpandingPlayer}
      className={`${
        expanded
          ? 'persistent-player__expand active'
          : 'persistent-player__expand'
      }`}
    >
      <svg width="12" height="6">
        <path
          d="M11.625 4.219l-5-4a1 1 0 0 0-1.25 0l-5 4c-.4313.3452-.5012.9747-.156 1.406.3452.4313.9747.5012 1.406.156L6 2.281l4.375 3.5c.4313.3452 1.0608.2753 1.406-.156.3452-.4313.2753-1.0608-.156-1.406z"
          fill="#444"
          fillRule="nonzero"
        />
      </svg>
    </button>
  );

  if (!audio) return <audio />;

  return (
    <React.Fragment>
      <AudioPlayerCore
        isPlaylist={(tracks?.length || 0) > 1}
        audio={audio}
        expandButton={renderExpandButton()}
        favoriteButton={renderFavoriteButton()}
        playlistButton={renderPlaylistButton()}
        playerIsExpanded={expanded}
      />

      {showPlaylistModal && (
        <MainModal title="Edit playlist" close={closePlaylistModal}>
          <PlaylistSelector
            trackId={audio!.id}
            type="audio"
            close={closePlaylistModal}
          />
        </MainModal>
      )}
    </React.Fragment>
  );
};
